import { EmailCodeVerificationService } from 'types/services';
import { m8API } from 'services/production/m8';
import { asyncTimeout } from 'utils/asyncTimeout';
import { DONE_TIMEOUT_DURATION } from 'utils/constants';

export const verifyEmailCode: EmailCodeVerificationService = async (params) => {
  const { code } = params;

  // Запрос отправляется без ожидания, чтобы он выполнялся параллельно
  // фиктивной задержке (нужно чтобы индикатор загрузки не мерцал из-за
  // быстрого выполнения запроса).
  // Promise.all не подходит, потому что в случае ошибки
  // фиктивная задержка будет прервана.

  const m8Request = m8API.auth.processAuthorizationEmailCode({
    code,
  });

  await asyncTimeout(DONE_TIMEOUT_DURATION);

  await m8Request;
};
